module.exports = __webpack_public_path__ + "img/hyal-3@2x.923fb4e1.png";